import type { FC } from 'react';

import ApprovalContainer from '../components/ApprovalContainer.jsx';
import PageHeader from '../components/PageHeader.jsx';

const ApprovalFlows: FC = () => {
  return (
    <div className="flex h-full flex-col gap-4">
      <PageHeader />
      <ApprovalContainer />
    </div>
  );
};

export default ApprovalFlows;
